import { mergeProps } from 'src/util'
import React from 'react'
import PropTypes from 'prop-types'
import { ChevronDownIcon, ChevronUpIcon } from 'src/components/icons'
import { BlockWrapper, BlockHeader, BlockContent } from '../common'
import styles from './CollapsibleBlock.scss'

/**
 * A collapsible block with default styles (background, border, radius, padding....)
 */

export default function CollapsibleBlock({
  defaultCollapsed,
  loading,
  headerProps,
  contentProps,
  title,
  children,
  toolbar,
  padding,
  ...props
}) {
  const [collapsed, toggleCollapsed] = React.useReducer(state => !state, defaultCollapsed)
  return (
    <BlockWrapper
      {...mergeProps()({ className: styles.collapsibleBlock }, { className: { [styles.collapsed]: collapsed } }, props)}
    >
      <BlockHeader
        {...mergeProps()(
          {
            className: styles.header,
            icon: collapsed ? ChevronDownIcon : ChevronUpIcon,
            toolbar,
            title,
            onClick: toggleCollapsed,
          },
          headerProps
        )}
      />
      <BlockContent {...mergeProps()({ className: styles.content, loading, padding }, contentProps)}>
        {children}
      </BlockContent>
    </BlockWrapper>
  )
}

CollapsibleBlock.propTypes = {
  /**
   * Whether the block is busy loading some content.
   */
  loading: PropTypes.bool,
  /**
   * The title to display in the block header.
   */
  title: PropTypes.node,
  /**
   * A toolbar node in the block header.
   */
  toolbar: PropTypes.node,
  /**
   * Props to apply to the block header.
   */
  headerProps: PropTypes.object,
  /**
   * Props to apply to the block content.
   */
  contentProps: PropTypes.object,
  /**
   * Whether the block is collapsed by default or not.
   */
  defaultCollapsed: PropTypes.bool,
  /**
   * The children of the block.
   */
  children: PropTypes.node,
  /**
   * The block content padding.
   */
  padding: PropTypes.string,
}
